import Plyr from 'plyr';
import gsap from 'gsap';
import { ev, isTablet, isPortrait, isMobile } from '../../../js/utils';
import $ from 'jquery';
import DragHandler from './dragHandler';

export class Video {
	constructor({ holder, settings }) {
		this.holder = holder;
		this.settings = settings;
		this.initialized = false;

		this.activeSegmentIndex = 0;
	}

	init() {
		this.initPlyr();
		this.attachEvents();
		this.initJSHovers();
		this.initJSClicks();
	}

	initPlyr() {
		if (!isPortrait() && !isMobile)
			this.holder.querySelector('video source').src = this.holder.querySelector('video source').dataset.src;

		if (isPortrait() || isMobile)
			this.holder.querySelector('video source').src = this.holder.querySelector('video source').dataset.mobSrc;

		this.holder.querySelector('video').load();

		this.player = new Plyr(this.holder.querySelector('video'), {
			hideControls: false,
			tooltips: { controls: false, seek: false },
			autoplay: this.settings?.autoplay ?? false,
			muted: true,
			clickToPlay: false,
			storage: { enabled: false, key: 'plyr' },
			fullscreen: {
				enabled: false,
			},
			controls: `<div class="plyr__controls">
            <button type="button" class="plyr__control plyr__control-play plyr__control-button" aria-label="Play, {title}" data-plyr="play">

            </button>
            <button type="button" class="plyr__control plyr__control-sound plyr__control-button" aria-label="Mute" data-plyr="mute">

            </button>
            <div class="plyr__progress">
                <div class="plyr__seek-wrap h-full overflow-hidden">
                    <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                </div>
                <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                <span role="tooltip" class="plyr__tooltip">00:00</span>
                ${this.settings.data}
            </div>
			<div class="mobile-controls-wrap absolute bottom-0 left-0 w-full h-[65px] z-1">
			  <div class="mobile-controls full-screen">
				<div class="controls__bar">
				  <div class="controls__thumb"></div>

				  <div class="controls__progress" ></div>
				  <div class="controls__load"></div>
				  <div class="controls__total"></div>
				</div>
			  </div>
			</div>
        </div>`,
		});

		this.videoSegments = this.holder.querySelectorAll('.video-segments .video-segment');
		this.videoRangeSlider = this.holder.querySelector('[data-plyr="seek"]');
		this.controls = this.holder.querySelector('.plyr__controls');
	}

	initTimeline() {
		const grif = this;
		const instance = this.player;
		//console.log('initTimeline');

		if (instance.duration < 2) {
			setTimeout(() => {
				//console.log('instance.duration before', instance.duration);
				this.initTimeline();
			}, 100);
			return;
		}

		if (isTablet) {
			this.dragHandler = new DragHandler(instance.duration, this.holder);
			this.dragHandler.events();

			this.player.on('play', (event) => {
				//console.log('play here');

				this.dragHandler.play();
			});

			this.player.on('pause', (event) => {
				//console.log('pause here');
				this.dragHandler.pause();
			});
		}

		this.initialized = true;

		this.initSegements();

		this.controls.classList.add('is-initialized');

		//console.log('instance.duration after', instance.duration);

		this.holder.querySelector('[data-video="culinary-btn"]').addEventListener('click', () => {
			ev('showCulinary', { type: this.settings.type });
		});

		this.holder.querySelector('[data-video="aisle"]').addEventListener('click', function () {
			ev('showAisle', { type: this.dataset.type });
		});
	}

	initSegements() {
		const instance = this.player;
		let lastSegmentStart = 0;

		this.videoSegments.forEach((el, i) => {
			const segment = el;
			const segmentDuration = +el.dataset.duration;
			el.dataset.start = lastSegmentStart;
			el.dataset.end = lastSegmentStart + segmentDuration;

			const segmentWidth = (segmentDuration / instance.duration) * 100;
			el.style.width = segmentWidth + '%';

			el.querySelectorAll('.key-moment, .interactive-point').forEach((el, i) => {
				const momentTimestamp = +el.dataset.timestamp;

				const timestampInSegemnt = momentTimestamp - lastSegmentStart;

				const positionLeft = (timestampInSegemnt / segmentDuration) * 100;

				if (el.dataset.duration) {
					const width = (+el.dataset.duration / segmentDuration) * 100;

					el.style.width = width + '%';
				}

				el.style.left = positionLeft + '%';

				if ($(el).hasClass('key-moment')) {
					const percentWidth = (el.offsetWidth / segment.offsetWidth) * 100;
					const newDuration = (percentWidth / 100) * segmentDuration;

					el.dataset.duration = newDuration;
				}
			});

			lastSegmentStart += segmentDuration;
		});
	}

	attachEvents() {
		this.player.on('ended', (event) => {
			const $btnBurger = $('.burger-btn-block .btn-burger');
			if (!$btnBurger.hasClass('is-active')) {
				$btnBurger.trigger('click');
			}
		});

		this.player.on('timeupdate', (event) => {
			const instance = event.detail.plyr;
			// console.log('timeupdate', instance.currentTime);

			this.videoSegments.forEach((el, i) => {
				const segmentStart = +el.dataset.start;
				const segmentEnd = +el.dataset.end;

				if (instance.currentTime > segmentStart && instance.currentTime < segmentEnd) {
					if (i != this.activeSegmentIndex) {
						this.activeSegmentIndex = i;
						this.updateActiveSegment(this.activeSegmentIndex);
					}
				}
			});

			this.holder.querySelectorAll('.key-moment, .interactive-point').forEach((el, i) => {
				const pointStart = +el.dataset.timestamp;
				const pointEnd = pointStart + +el.dataset.duration;
				const pointDuration = +el.dataset.duration;
				
				// console.log((instance.currentTime - pointStart) / pointDuration);
				let pointProgress = (instance.currentTime - pointStart) / pointDuration;
				pointProgress = Math.min(Math.max(pointProgress, 0), 1);

				if (el.querySelector('.interactive-point_inner')) {
					gsap.set(el.querySelector('.interactive-point_inner'), { width: pointProgress * 100 + '%' });
				}

				if (el.querySelector('.key-moment_heart-fill')) {
					const invertedProgress = 1 - pointProgress;
					gsap.set(el.querySelector('.key-moment_heart-fill'), { strokeDashoffset: invertedProgress * 34 });
				}

				if (instance.currentTime > pointStart && instance.currentTime < pointEnd) {
					el.classList.add('is-inrange');
				} else {
					el.classList.remove('is-inrange');
				}
			});

			var currentTime = instance.currentTime;
            var percent = (currentTime/instance.duration);
			document.body.dispatchEvent(
				new CustomEvent("data-video", { detail: percent })
			);
		});
	}

	updateActiveSegment(activeSegmentIndex) {
		this.videoSegments.forEach((el, i) => {
			el.classList.remove('is-active');
		});

		this.videoSegments[activeSegmentIndex].classList.add('is-active');
	}

	initJSHovers() {
		const jsHoverItems = Array.from(this.holder.querySelectorAll('.key-moment, .interactive-point')).map(
			(el, i) => {
				return {
					element: el,
					hovered: false,
				};
			},
		);

		document.addEventListener('mousemove', handleMouseMove);

		function handleMouseMove(event) {
			// Get the mouse coordinates
			const mouseX = event.clientX;
			const mouseY = event.clientY;

			jsHoverItems.forEach((item, i) => {
				// Get the position and dimensions of the target element
				const targetRect = item.element.getBoundingClientRect();
				const targetLeft = targetRect.left;
				const targetTop = targetRect.top - 50;
				const targetRight = targetRect.right;
				const targetBottom = targetRect.bottom;

				// Check if the mouse is inside the target element
				if (mouseX <= 150) {
					return;
				} else if (
					mouseX >= targetLeft &&
					mouseX <= targetRight &&
					mouseY >= targetTop &&
					mouseY <= targetBottom
				) {
					if (!item.hovered) item.element.classList.add('is-hovered');
					item.hovered = true;
				} else {
					if (item.hovered) item.element.classList.remove('is-hovered');
					item.hovered = false;
				}
			});
		}
	}


	initJSClicks() {
		const jsClickItems = this.holder.querySelectorAll('.key-moment');

		document.addEventListener('click', handleMouseClick, false);

		function handleMouseClick(event) {
			// Get the mouse coordinates
			const mouseX = event.clientX;
			const mouseY = event.clientY;

			jsClickItems.forEach((item, i) => {
				// Get the position and dimensions of the target element
				const targetRect = item.getBoundingClientRect();
				const targetLeft = targetRect.left;
				const targetTop = targetRect.top - 50;
				const targetRight = targetRect.right;
				const targetBottom = targetRect.bottom;

				// Check if the mouse is inside the target element
				if (mouseX <= 150) {
					return;
				} else if (
					mouseX >= targetLeft &&
					mouseX <= targetRight &&
					mouseY >= targetTop &&
					mouseY <= targetBottom
				) {
					document.body.dispatchEvent(
						new CustomEvent("data-analytics-key-moment", { detail: item })
					);
				}
			});
		}
	}
}
